import { useEffect, useRef, useState } from "react";
import { FileManager } from "@cubone/react-file-manager";
import "@cubone/react-file-manager/dist/style.css";
import {  useToast } from "@chakra-ui/react";
import { useSession } from "../../../../SessionContext";
import { useNavigate } from "react-router-dom";
import createAxiosInstance from "../../../../interceptors/useAxiosInterceptors";
import logout from "../../../../services/authService";
import { copyFile, copyFolder, createNewFolder, deleteFile, deleteFolder, downloadFile, downloadFolder, getLcaRepository, initLcaRepositoryHttpService, moveFile, moveFolder, renameFile, renameFolder } from "../../../../services/http/lcaRepositoryHttpService";
import { useTranslation } from "react-i18next";
import { react_api } from "../../../../config";


function FileManagerGrins() {
  const [files, setFiles] = useState([]);
  const toast = useToast();

  const { t } = useTranslation();


  const [isLoading, setIsLoading] = useState(false);
  const { clearSessionData } = useSession();

  const navigate = useNavigate();
  
  function removeLeadingSlash(str) {
    return str.startsWith("/") ? str.slice(1) : str;
  }
  
  const uploadHeadersRef = useRef({path: "",fileName: "" ,owners: [], folderId: "", isReadOnly: false});

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });

function clearDescription() {
  const textarea = document.querySelector('textarea.custom-description');
  const wrapper = document.querySelector('.textarea-wrapper');
  const button = document.querySelector('button.fm-button.fm-button-primary');
  const errorMessage = document.querySelector('#description-error');
  
  if (textarea) {
    // Reset del contenuto
    textarea.value = '';
    textarea.focus();
    
    // Reset dello stato globale
    if (window.windowsTmp) {
      window.windowsTmp.description = '';
    }
    
    // Reset dell'aspetto visivo
    if (wrapper) {
      wrapper.style.borderColor = '#e53e3e';
      wrapper.style.backgroundColor = '#fef5f5';
    }
    
    textarea.style.borderColor = '#e53e3e';
    textarea.style.backgroundColor = 'white';
    textarea.setAttribute('aria-invalid', 'true');
    
    // Reset del bottone
    if (button) {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
    }
    
    // Nascondi messaggi di errore
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    // Reset del label
    const label = document.querySelector('#description-label');
    if (label) {
      label.style.color = '#c53030';
      label.textContent = '⚠️ ATTENZIONE: Descrizione Obbligatoria';
    }
    
    
  }
}

  const initFileManager = ()=> {
    getLcaRepository().then(res => {
      
      let data  = res.data.map(item => ({
        ...item,
        path: item.path.endsWith('/') ? item.path.slice(0, -1) : item.path
      }));
      window.files = data;
      setFiles(data)
     })

   
  
  };

  initLcaRepositoryHttpService(t, toast, axiosInstance);

   useEffect(() => {
  initFileManager(); 
  

    document.querySelectorAll('.item-action').forEach(el => {
    const span = el.querySelector('span');
      if (!span || span.textContent.trim() !== 'Download') {
    el.style.display = 'none';
        }
    });

    document.querySelectorAll('.fm-context-menu').forEach(el => {
    el.style.display = 'none';
    });   
    function getIsHome() {
    

    const breadcrumb = document.querySelector(".breadcrumb");
    const folderNames = breadcrumb?.querySelectorAll(".folder-name");
    
    if (folderNames &&folderNames.length === 1 && folderNames[0].textContent.trim() === "Home") {
      window.isHome  = true
      window.currentPath ="/"
      return true;
      
    }

      
    return false
  
  }

 function getCurrentPath() {
   

    const breadcrumb = document.querySelector(".breadcrumb");
    const folderNames = breadcrumb?.querySelectorAll(".folder-name");
    
    if (folderNames && folderNames.length > 1) {
      let currentPathLca = Array.from(folderNames)
        .slice(1)
        .map((span) => span.textContent.trim())
        .join("/");

     

      if(currentPathLca) {
        window.currentPath = currentPathLca;
        return true
      } else {
        return false
      }

      }
    // Rimuovi barra di progresso
      }



function addDescriptionTextarea() {
  const modalHeader = document.querySelector('.fm-modal-header');
  const button = document.querySelector('button.fm-button.fm-button-primary');
  const label = document.querySelector('label[for="chooseFile"]');
  window.windowsTmp = window.windowsTmp || {};

  if (
    modalHeader &&
    !modalHeader.querySelector('textarea.custom-description') &&
    button && label
  ) {
    const wrapper = document.createElement('div');
    wrapper.className = 'textarea-wrapper';
    wrapper.setAttribute('role', 'group');
    wrapper.setAttribute('aria-labelledby', 'description-label');
    wrapper.style.cssText = `
      border: 2px solid #e53e3e;
      border-radius: 4px;
      padding: 6px 12px 12px;
      margin-top: 12px;
      display: flex;
      height: 110px;
      flex-direction: column;
      gap: 6px;
      width: 100%;
      box-sizing: border-box;
      background: #fef5f5;
      flex-basis: 100%;
      order: 999;
    `;

    // Label principale
    const labelDesc = document.createElement('label');
    labelDesc.id = 'description-label';
    labelDesc.textContent = '⚠️ ATTENZIONE: Descrizione Obbligatoria';
    labelDesc.style.cssText = `
      font-weight: 700;
      font-size: 14px;
      color: #c53030;
      user-select: none;
      display: flex;
      align-items: center;
      gap: 8px;
    `;

    // Messaggio di istruzioni
    const instructionText = document.createElement('div');
    instructionText.id = 'description-instructions';
    instructionText.textContent = 'Prima di selezionare un file, devi inserire una descrizione dettagliata del contenuto';
    instructionText.setAttribute('role', 'alert');
    instructionText.setAttribute('aria-live', 'polite');
    instructionText.style.cssText = `
      font-size: 12px;
      color: #744210;
      font-style: italic;
      background: #fefcbf;
      padding: 4px 8px;
      border-radius: 3px;
      border-left: 3px solid #d69e2e;
    `;

    // textarea
    const textarea = document.createElement('textarea');
    textarea.className = 'custom-description';
    textarea.id = 'file-description';
    textarea.rows = 3;
    textarea.placeholder = 'Inserisci una descrizione dettagliata del file che vuoi caricare...';
    textarea.setAttribute('aria-required', 'true');
    textarea.setAttribute('aria-describedby', 'description-instructions description-error');
    textarea.setAttribute('aria-invalid', 'true');
    textarea.style.cssText = `
      width: 100%;
      padding: 8px;
      font-size: 14px;
      border: 2px solid #e53e3e;
      border-radius: 4px;
      outline: none;
      resize: vertical;
      font-family: inherit;
      background: white;
      transition: border-color 0.2s ease;
    `;

    // Messaggio di errore (inizialmente nascosto)
    const errorMessage = document.createElement('div');
    errorMessage.id = 'description-error';
    errorMessage.setAttribute('role', 'alert');
    errorMessage.setAttribute('aria-live', 'assertive');
    errorMessage.style.cssText = `
      color: #c53030;
      font-size: 12px;
      font-weight: 600;
      display: none;
    `;

    wrapper.appendChild(labelDesc);
    wrapper.appendChild(instructionText);
    wrapper.appendChild(textarea);
    wrapper.appendChild(errorMessage);

    // Ensure the modal header allows wrapping and add the textarea
    modalHeader.style.flexWrap = 'wrap';
    modalHeader.appendChild(wrapper);

    const updateAccessibilityState = (isValid) => {
      if (isValid) {
        // Stato valido
        textarea.style.borderColor = '#38a169';
        textarea.style.backgroundColor = '#f0fff4';
        textarea.setAttribute('aria-invalid', 'false');
        wrapper.style.borderColor = '#38a169';
        wrapper.style.backgroundColor = '#f0fff4';
        labelDesc.style.color = '#2f855a';
        labelDesc.textContent = '✅ Descrizione inserita correttamente';
        errorMessage.style.display = 'none';
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        label.style.opacity = '1';
        label.style.cursor = 'pointer';
      } else {
        // Stato non valido
        textarea.style.borderColor = '#e53e3e';
        textarea.style.backgroundColor = 'white';
        textarea.setAttribute('aria-invalid', 'true');
        wrapper.style.borderColor = '#e53e3e';
        wrapper.style.backgroundColor = '#fef5f5';
        labelDesc.style.color = '#c53030';
        labelDesc.textContent = '⚠️ ATTENZIONE: Descrizione Obbligatoria';
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        label.style.opacity = '0.5';
        label.style.cursor = 'not-allowed';
      }
    };

    const checkDescription = () => {
      const trimmed = textarea.value.trim();
      window.windowsTmp.description = trimmed;

      const isEmpty = trimmed.length === 0;
      const isValid = !isEmpty && trimmed.length >= 5; // Minimo 10 caratteri
      
      button.disabled = !isValid;
      updateAccessibilityState(isValid);

      if (!isEmpty && trimmed.length < 5) {
        errorMessage.textContent = 'La descrizione deve contenere almeno 5 caratteri';
        errorMessage.style.display = 'block';
      } else {
        errorMessage.style.display = 'none';
      }
    };

    // Inizializza stato
    checkDescription();

    const dragContainer = document.querySelector('.draggable-file-input');
    const preventDrag = (e) => {
      if (!window.windowsTmp.description || window.windowsTmp.description.trim() === '' || window.windowsTmp.description.trim().length < 5) {
        e.preventDefault();
        e.stopPropagation();
        
        // Mostra messaggio di errore visivamente
        errorMessage.textContent = 'Completa prima la descrizione del file!';
        errorMessage.style.display = 'block';
        textarea.focus();
        
        // Effetto visivo di attenzione
        wrapper.style.animation = 'shake 0.5s ease-in-out';
        setTimeout(() => {
          wrapper.style.animation = '';
        }, 500);
      }
    };

    if (dragContainer) {
      dragContainer.addEventListener('dragover', preventDrag);
      dragContainer.addEventListener('drop', preventDrag);
    }

    // Su ogni input aggiorna
    textarea.addEventListener('input', checkDescription);
    
    // Focus management
    textarea.addEventListener('focus', () => {
      wrapper.style.boxShadow = '0 0 0 3px rgba(66, 153, 225, 0.6)';
    });
    
    textarea.addEventListener('blur', () => {
      wrapper.style.boxShadow = 'none';
    });

    // Blocca apertura se vuoto
    label.addEventListener('click', (e) => {
      if (!window.windowsTmp.description || window.windowsTmp.description.trim() === '' || window.windowsTmp.description.trim().length < 5) {
        e.preventDefault();
        e.stopPropagation();
        
        errorMessage.textContent = 'Devi inserire una descrizione di almeno 5 caratteri prima di selezionare un file!';
        errorMessage.style.display = 'block';
        textarea.focus();
        
        // Effetto shake
        wrapper.style.animation = 'shake 0.5s ease-in-out';
        setTimeout(() => {
          wrapper.style.animation = '';
        }, 500);
      }
    });

    // Aggiungi CSS per l'animazione shake
    if (!document.querySelector('#shake-animation-style')) {
      const style = document.createElement('style');
      style.id = 'shake-animation-style';
      style.textContent = `
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
      `;
      document.head.appendChild(style);
    }

    return true;
  }

  return false;
}

// Prova ad aggiungere la textarea subito, altrimenti osserva i cambiamenti del DOM
//addDescriptionTextarea()

  if(!addDescriptionTextarea()) {
  const observer = new MutationObserver((mutations, obs) => {
    addDescriptionTextarea()

  });

  observer.observe(document.body, { childList: true, subtree: true });
  }



  const observer = new MutationObserver((mutations, obs) => {
    window.isHome =  false;
    window.currentPath= null;


  
 
    document.querySelectorAll('.item-action').forEach(el => {
  const span = el.querySelector('span');
  if (!span || span.textContent.trim() !== 'Download') {
    el.style.display = 'none';
  }
});

   document.querySelectorAll('.fm-context-menu').forEach(el => {
    el.style.display = 'none';
    });   


    getCurrentPath()
    getIsHome()

 


    if(window.isHome) {
    

      

   document.querySelectorAll('.item-action').forEach(el => {
  const span = el.querySelector('span');
  if (!span || span.textContent.trim() !== 'Download') {
    el.style.display = 'none';
  }
});



 
   document.querySelectorAll('.fm-context-menu').forEach(el => {
      el.style.display = 'none';
    });    

         
        
    }else {
       if(window.currentPath) {
    
      const currentDir = window.files.find((file) => file.path === window.currentPath);
      const username = sessionStorage.getItem("username");
        
        
      if (currentDir && currentDir.owners.includes(username)) {
       

        

       

  document.querySelectorAll('.item-action').forEach(el => {
    el.style.display = 'inline-flex';
  });

  document.querySelectorAll('.fm-context-menu').forEach(el => {
    el.style.display = 'block';
  });   


      }
       }}

       

  


 


 

 

        
  });

  observer.observe(document.body, { childList: true, subtree: true });
     
  }, []);
  


  
  const normalizedFiles = (files)=>  files.map(file => ({
    ...file,
    path: "/" + file.path, // aggiunge lo slash iniziale
  }));


  function isValidFileName(filename) {
    return /\.(zip|rar|xlsx?|pdf)$/i.test(filename);
  }

  function updatePaths(tree, targetId, oldPath, newPath, newName) {
    return tree.map(item => {
      if (item._id === targetId) {
        // Nodo principale rinominato
        const updatedItem = {
          ...item,
          name: newName,
          path: newPath,
          children: item.children
            ? updatePaths(item.children, null, oldPath, newPath, newName)
            : [],
        };
        return updatedItem;
      } else if (item.path.startsWith(oldPath)) {
        // Nodo figlio della cartella rinominata
        const updatedChildPath = item.path.replace(oldPath, newPath);
        return {
          ...item,
          path: updatedChildPath,
          children: item.children
            ? updatePaths(item.children, null, oldPath, newPath, newName)
            : [],
        };
      } else {
        // Nessuna modifica
        return {
          ...item,
          children: item.children
            ? updatePaths(item.children, targetId, oldPath, newPath, newName)
            : [],
        };
      }
    });
  }
  return (
    <>

<style>{`
     .rename-file {
  color: black !important;
  background-color: white !important;
  font-size: 1rem !important;
}

.close-icon {
  width: 36px;
  height: 36px;
}

.item-action.hidden {
  display: none;
}
`}</style>





      <FileManager enableFilePreview={false} height={"100%"} initialPath="/LCI_REPOSITORY/DATABASE" fontFamily={"'Roboto', sans-serif"} primaryColor={"#0d4e59"}  files={normalizedFiles(files)}  
        
      isLoading={isLoading}
      fileUploadConfig={ {url: `${react_api}/lca-repo/uploadFile`, method: "POST" , headers: ()=>  uploadHeadersRef.current }} 
      
      acceptedFileTypes={".zip,.rar,.xlsx,.xls,.pdf"}  
      
      onRefresh={()=> {
        initFileManager()
      }}


      onCreateFolder={(name, parentFolder)=> {
        setIsLoading(true)
        
        
 
        if(parentFolder != null) {
          
          createNewFolder({
            name,
            isDirectory: true,
            path:  removeLeadingSlash(parentFolder.path.replace(/^\/+/, '') + "/"+ name +"/") ,
            owners: [sessionStorage.getItem("username")],
            updatedAt: new Date().toISOString().split('.')[0] + 'Z'

         },parentFolder._id,()=> {
         
 
         }).then(res => { 


          if(res && res._id) {


            let newFolder =  {
            
              _id : res._id,
              name: name,
              isDirectory: true,
              path: parentFolder.path.replace(/^\/+/, '') + "/"+ name ,
              owners: [sessionStorage.getItem("username")],
              updatedAt: new Date().toISOString().split('.')[0] + 'Z',
              isReadOnly: false
            };

            setFiles(prevFiles => [...prevFiles, newFolder]);

            window.files.push(newFolder)

          
            setIsLoading(false)
          }

          

         

         }).catch(()=> {
            setIsLoading(false)
         })
        }
        
       

      }}

     


      onFileUploaded={((response)=> {
        
        


        let json = JSON.parse(response)

        if(json.status === "200") {
          toast.closeAll(); 
           toast({
      title: "File caricato con successo",
      status: 'success',
      duration: 1500,
      position: 'top',
      isClosable: true
    });
  
    clearDescription()
  }else {
    toast.closeAll(); 
          toast({
              title: "Errore",
              description: json.message,
              status: 'warning',
              duration: 4000,
              position: 'top',
              isClosable: true
            });
        }
        
        

        initFileManager()
      })}

      onFileUploading={((file,parentFolder)=> {

       
        if(parentFolder != null) {
          uploadHeadersRef.current = {
            
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token")};  
        
        }


        if(!isValidFileName(file.name)) {
          return 
        }

       

          return {
            description: window.windowsTmp.description,
            filePath:  removeLeadingSlash(parentFolder.path.replace(/^\/+/, '') + "/") ,
            fileName: file.name ,'X-File-Owner': sessionStorage.getItem("username"),
            owners: new Blob([JSON.stringify([sessionStorage.getItem("username")])], {type:'application/json'}),
            folderId: parentFolder._id,
            isReadOnly: "false"
          };

        
        

        
      

      })}

      onDownload={(files)=> {
        setIsLoading(true)
      

        files.forEach(file => {

          if(!file.isReadOnly) {
            if(file.isDirectory) {
              downloadFolder( removeLeadingSlash(file.path +"/"), [sessionStorage.getItem("username")], file._id).then(res=> {
                setIsLoading(false)
              }).catch(e=> {
                setIsLoading(false)
              })
            }else {
              downloadFile( removeLeadingSlash(file.path) , [sessionStorage.getItem("username")], file._id).then(res=> {
                setIsLoading(false)
              }).catch(e=> {
                setIsLoading(false)
              })
            }
          }else {
            toast.closeAll(); 
            toast({
              title: "Errore",
              description: "Operazione non permessa",
              status: 'warning',
              duration: 4000,
              position: 'top',
              isClosable: true
            });
            setIsLoading(false)
          }

          
        })
     

        
      }}

      onRename={((file,newName)=> {
        

        setIsLoading(true)
        if(!file.isReadOnly && file.name !== newName) { 
          if(file.isDirectory) {
      
           
            renameFolder({

              id: file._id,
              newName: newName,
              oldPath:  removeLeadingSlash(file.path +"/"),
              owners: [sessionStorage.getItem("username")]
    
            }, ()=> {}).then(res => {

              if(res && res._id) {
                setFiles(prevFiles =>
                  updatePaths(prevFiles, res._id, file.path, res.newPath, newName)
                );
              
                setIsLoading(false);

              }


              
              
            }).catch(()=> {
              setIsLoading(false);
            })
          }else {
            renameFile({

              id: file._id,
              newName: newName,
              oldPath:  removeLeadingSlash(file.path +"/"),
              owners: [sessionStorage.getItem("username")]
    
            }, ()=> {}).then(res => {

              if(res && res._id) {
                setFiles(prevFiles =>
                  prevFiles.map(file =>
                    file._id === res._id
                      ? { ...file, name : newName , path: res.newPath } 
                      : file 
                  )
                );

                setIsLoading(false)

              }


              
              
            }).catch(()=> {
              
                setIsLoading(false)
            })
          }
        }else {
          setIsLoading(false)
          toast.closeAll(); 
          toast({
            title: "Errore",
            description: "Operazione non permessa",
            status: 'warning',
            duration: 4000,
            position: 'top',
            isClosable: true
          });
        }

       
           



        

      })}

      

      

      onPaste={(filesSelected, destinationFolder, operationType)=> {
         



          setIsLoading(true)
          

          switch(operationType) {
            case "move":


            filesSelected.forEach(file=> {

         
            if(!file.isReadOnly && file.path !== destinationFolder.path) {

                if(file.isDirectory) {

              

                       if(files.find(folderRes => folderRes.name === file.name && folderRes.path === removeLeadingSlash(destinationFolder.path + "/" + file.name ) )) {
                          setIsLoading(false)
                            toast({
                            title: "Errore operazione non permessa",
                            description: "Cartella già esistente",
                            status: 'warning',
                            duration: 4000,
                            position: 'top',
                            isClosable: true
                          });
                          return
                        }

               
                    moveFolder({

                      id: file._id,
                      sourcePath:    removeLeadingSlash(file.path + "/"),
                      destinationPath:  removeLeadingSlash(destinationFolder.path + "/"),
                      owners: [sessionStorage.getItem("username")]
  
                    },()=> {
                      
  
                    }).then((res)=> {
                        

                      if (res && res.data && res.data.length > 0) {
                        let newItems = res.data.map(item => ({
                          ...item,
                          path: item.path.endsWith("/") ? item.path.slice(0, -1) : item.path
                        }));
                      
                        setFiles(prev => {
                          const idsToReplace = newItems.map(i => i._id);
                          const filtered = prev.filter(f => !idsToReplace.includes(f._id));
                          window.files = [...filtered, ...newItems]
                          return [...filtered, ...newItems];
                        });

                        
                      }else {
                        
                       

                        setFiles(prev => prev.map(f => f._id === file._id ? { ...f, path: removeLeadingSlash(destinationFolder.path + "/") + file.name } : f));

                       

                        
                      }



                    

                      setIsLoading(false)

                    }).catch(()=> {
                       setIsLoading(false)
                    })
                  }else {


                       if(files.find(fileRes => fileRes.name === file.name && fileRes.path === removeLeadingSlash(destinationFolder.path +"/" + file.name ) )) {
                          setIsLoading(false)
                            toast({
                            title: "Errore operazione non permessa",
                            description: "File già esistente",
                            status: 'warning',
                            duration: 4000,
                            position: 'top',
                            isClosable: true
                          });
                          return
                        }

                    moveFile({

                      id: file._id,
                      fileName: file.name,
                      sourcePath:  removeLeadingSlash(file.path) ,
                      destinationPath:  removeLeadingSlash(destinationFolder.path +"/" + file.name) ,
                      owners: [sessionStorage.getItem("username")]
  
                    },()=> {
                      
  
                    }).then((res)=> {
                      const newItem = {
                        _id: file._id,
                        name: file.name,
                        path: removeLeadingSlash(destinationFolder.path +"/" + file.name),
                        isDirectory: false,
                        isReadOnly: false,
                        owner: sessionStorage.getItem("username")
                      };
                       window.files.push(newItem)
                      setFiles(prev =>
                        [
                          ...prev.filter(f => f._id !== file._id),
                          newItem                                
                        ]
                      );

                      setIsLoading(false)

                    }).catch(()=> {
                       setIsLoading(false)

                    })
                    

                  }

                 
                
            }else {
              setIsLoading(false)
              toast.closeAll(); 
              toast({
            title: "Errore",
            description: "Operazione non permessa",
            status: 'warning',
            duration: 4000,
            position: 'top',
            isClosable: true
          });
            }
            })
            


            break;
            
            case "copy":

            
            filesSelected.forEach(file=> {

         
              if(!file.isReadOnly && file.path !== destinationFolder.path) {
  
                  if(file.isDirectory) {
  
                        

                        if(files.find(folderRes => folderRes.name === file.name && folderRes.path === removeLeadingSlash(destinationFolder.path +"/"+ file.name ) )) {
                          setIsLoading(false)
                            toast({
                            title: "Errore operazione non permessa",
                            description: "Cartella già esistente",
                            status: 'warning',
                            duration: 4000,
                            position: 'top',
                            isClosable: true
                          });
                          return
                        }

  
                 
                      copyFolder({
  
                        id: file._id,
                        folderName: file.name,
                        sourcePath:  removeLeadingSlash(file.path + "/"),
                        destinationPath:  removeLeadingSlash(destinationFolder.path + "/"),
                        owners: [sessionStorage.getItem("username")]
    
                      },()=> {
                        
                        setIsLoading(false)
                      }).then((res)=> {


                      
  
                        const cleanData = res.data.map(item => {
                          const { message, ...rest } = item; // rimuove "message"
                          return {
                            ...rest,
                            path:removeLeadingSlash( rest.path.endsWith("/") ? rest.path.slice(0, -1) : rest.path) // rimuove "/" finale
                          };
                        });
                        setFiles(prev =>{ 
                          
                          let data = [...prev, ...cleanData];
                           window.files =data
                          return data});

                      }).catch(e=> {
                        setIsLoading(false)
                      })
                    }else {
                      


                         if(files.find(fileRes => fileRes.name === file.name && fileRes.path ===  removeLeadingSlash(destinationFolder.path +"/" + file.name) )) {
                          setIsLoading(false)
                            toast({
                            title: "Errore operazione non permessa",
                            description: "File già esistente",
                            status: 'warning',
                            duration: 4000,
                            position: 'top',
                            isClosable: true
                          });
                          return
                        }

                      copyFile({
  
                        id: file._id,
                        fileName: file.name,
                        sourcePath:  removeLeadingSlash(file.path),
                        destinationPath:  removeLeadingSlash(destinationFolder.path +"/" + file.name),
                        owners: [sessionStorage.getItem("username")]
    
                      },()=> {
                        
    
                      }).then((res)=> {
                        

                        const newItem = {
                          _id: res._id,
                          name: file.name,
                          path: removeLeadingSlash(destinationFolder.path +"/" + file.name),
                          isDirectory: false,
                          isReadOnly: false,
                          owner: sessionStorage.getItem("username")
                        };
                        setFiles(prev => [...prev, newItem]);
                        window.files.push(newItem)
                        setIsLoading(false)
                      }).catch(e=> {
                        setIsLoading(false)
                      })
                      
  
                    }
  
                   
                  
              }else {
                 setIsLoading(false)
                 toast.closeAll(); 
          toast({
            title: "Errore",
            description: "Operazione non permessa",
            status: 'warning',
            duration: 4000,
            position: 'top',
            isClosable: true
          });
              }
              })

            break;


            default:
              break;
          }

         
      }}

      onDelete={(files)=> {
      


        
        files.forEach(file => {



  if(!file.isReadOnly) { 
    if(file.isDirectory) {

    

      if(file.owners == null) {
        file.owners = [sessionStorage.getItem("username")]
      }
    
      deleteFolder({id: file._id, path:  removeLeadingSlash(file.path +"/") ,owners: file.owners} , ()=> {}).then(res=> {
        

        setFiles((prevFolders) => prevFolders.filter((folderRes) => folderRes._id !== file._id));

      })
    }else {
      deleteFile({id: file._id, path:  removeLeadingSlash(file.path)  , owners: file.owners} , ()=> {}).then(res=> {
        setFiles((prevFiles) => prevFiles.filter((fileRes) => fileRes._id !== file._id));
      })
    }
  
    }else {
toast.closeAll(); 
      toast({
        title: "Errore",
        description: "Operazione non permessa",
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }


        })
       
      }}
      
      />
    </>
  );
}

export default FileManagerGrins;